import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { useLoginContext } from "../../../../context/loginContext";
import { utils } from "../../../../utils/globalVariables";

import ModalResponse from "../../../../components/general/ModalResponse";

import Invoice from "./Invoice";
import invoiceApi from "../api/invoiceApi";

const INVBBComponent = ({ stateDT }) => {

    const { loginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetDataInvoice: 'INVBBComponent-1',
    })

    const [data, setData] = React.useState({
        devDataPDF: [],
        devDataPDFProject: [],
        devDataPDFLoading: false,
        devDataCancelPDF: null,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        // Membuat sumber pembatalan saat komponen dimuat
        const source = axios.CancelToken.source();
        setData(d => ({ ...d, devDataCancelPDF: source }))

        // Membersihkan sumber pembatalan saat komponen dilepas
        return () => {
            if (source) {
                source.cancel('Request canceled by user');
            }
        };
    }, []);

    // info : (jgn dihapus) Membersihkan sumber pembatalan saat pengguna pindah halaman
    // React.useEffect(() => {
    //     const cleanup = () => {
    //         if (data.devDataCancelPDF) {
    //             data.devDataCancelPDF.cancel('Request canceled by user');
    //         }
    //     };

    //     // Membersihkan sumber pembatalan saat pengguna pindah halaman
    //     return () => {
    //         cleanup();
    //     };
    // }, [history, data.devDataCancelPDF]);

    const fnSetDataForPDF = () => {
        setData(d => ({ ...d, devDataPDFLoading: true }));

        invoiceApi.fetchData({
            stateData: {
                loginContextSyswebapp: loginContext.syswebapp,
                projectId: stateDT.projectId,
                projectStep: stateDT.projectStep,
                projectIsCancel: stateDT.projectIsCancel,
                cancelToken: data.devDataCancelPDF?.token,
            }
        })
            .then(data => {
                setData(d => ({ ...d, devDataPDFLoading: false }));

                if (data?.flag_status === 'no-data') {
                    notifications.show({
                        id: notificationId.current.errorGetDataInvoice,
                        title: utils.notification.warning.caption,
                        message: 'Data nota tidak ditemukan.',
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                } else {
                    if (Array.isArray(data.item_jasa) && (data.item_jasa.length > 0)) {
                        setData(d => ({
                            ...d,
                            devDataPDF: data.item_jasa,
                            devDataPDFProject: data.project
                        }));
                    } else {
                        setData(d => ({
                            ...d,
                            modalResponse: {
                                ...d.modalResponse,
                                type: utils.modalResponse.warning,
                                hideOnClickOutSide: true,
                                content: 'Tidak Ada Penggunaan Stok/Jasa',
                                show: true
                            }
                        }))
                    }
                }
            })
            .catch(error => {
                setData(d => ({ ...d, devDataPDFLoading: false }))

                if (axios.isCancel(error)) {
                    // konsol . log('Request canceled:', error.message);
                } else {
                    // konsol . log('Error fetching data:', error);
                }
            });
    }

    return (
        <React.Fragment>
            <Invoice
                stateData={data.devDataPDF}
                stateDataProject={data.devDataPDFProject}
                stateCaption={stateDT.caption}

                stateProjectId={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].project_id : ''}

                stateCustomerName={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].customer_name : ''}

                stateCustomerContact={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? (data.devDataPDFProject[0].customer_contact ? data.devDataPDFProject[0].customer_contact : '') : ''}

                stateTanggalNota={Array.isArray(data.devDataPDFProject) && (data.devDataPDFProject.length > 0) ? data.devDataPDFProject[0].tanggal_nota : ''}

                stateLoading={data.devDataPDFLoading}
                fnSetIdleData={() => setData(d => ({ ...d, devDataPDF: [] }))}
                fnGetData={fnSetDataForPDF}

                stateDT={{
                    projectId: stateDT.projectId,
                    projectStep: stateDT.projectStep,
                    projectIsCancel: stateDT.projectIsCancel,
                    jenisDokumen: stateDT.jenisDokumen
                }}
            />

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateOverlayZIndex={201}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default INVBBComponent;